<template>
    <div>
        <HeaderTopComponent v-if="!menuMovil" />
        <MenuComponent 
            background='' 
            :dense='false' 
            styleRow='margin-top: 0px'
             v-if="!menuMovil"
        />
         <MenuMovilComponent v-if="menuMovil" class='px-6 px-sm-10'/>
        <v-img :src="`${require('@/assets/banner-nosotros.jpg')}`" :class="`${scrollTop ? '' : 'mt-180'}`"></v-img> 
        <BreadCrumbsComponent :breadcrumbs=breadcrumbs class="margin-breadcrumb"/>       
        <div class="mx-5 mx-sm-10 mx-md-16 px-md-16 my-6">
            <h1 class="display-1 font-weight-bold color-title font-title"><i>Grupo Innofarm</i></h1>
            <h1 class="font-size-custom font-weight-bold color-title font-title"><i>MEDICINA INTEGRAL DE ESPECIALIDAD</i></h1>
        </div>
        <div class="mx-5 mx-sm-10 mx-md-16 px-md-16 my-8 font-text">
            <p>
                Somos una empresa de la salud, creada en el año 2012, que brinda <b>atención integral</b> 
                a pacientes con patologías de larga duración y <b>servicios corporativos</b>
                a empresas generales y de la salud.
            </p>
            <p>
                Facilitamos <b>la venta y la aplicación de medicinas de especialidad,</b> como el acceso a <b>análisis de laboratorio</b> 
                entre <a href='/servicios'>otros servicios</a> que podrá solicitar tanto a domicilio como en cada una de nuestras <a href='/sedes'>sedes</a>.
            </p>
            <p>
                Asimismo ofrecemos <b>medicinas, insumos y equipos</b> a instituciones de la salud. Y brindamos el servicio de <b>seguridad ocupacional</b> para todas las empresas. 
                <br />
                Entre otros <a href='/empresas_pymes'>servicios corporativos</a> como la representación de marca.

            </p>
            <p>
                En nuestra matriz de la ciudad de <a href='/sedes/farmacia-quito'>Quito</a>, contamos con <b>farmacia de especialidad, centro de aplicaciones y laboratorio.</b>
                En enero del año 2021, fue inaugurada nuestra sucursal de la ciudad <a href='/sedes/farmacia-guayaquil'>Guayaquil</a>, donde puede adquirir y aplicarse las medicinas que necesite, beneficiándose de nuestras cómodas y modernas instalaciones. 
            </p>
            <p>
                Contamos con la <b>infraestructura y la tecnología</b> para brindarle resultados precisos, respaldados por nuestro equipo de trabajo, comprometido y capaz. <br />
                Cabe destacar que otorgamos cobertura en la <b>distribución de medicinas de especialidad</b> en todo el territorio de Ecuador; asegurando la cadena de frío de 2 a 8 grados a través de un sistema computarizado de excelencia. 
            </p>
            <p>
               <b>Nuestra misión es impulsar el bienestar. Estamos aquí para contribuir a mejorar la calidad de vida de cada uno de nuestros pacientes a través de nuestros servicios integrales, de la mano de la calidez y el profesionalismo que nos representa.</b>
            </p>
        </div>
        <div class="mx-5 mx-sm-10 mx-md-16 pt-md-16 px-md-16 mt-16">
            <v-row align="center" justify="center">
                <v-col cols="12" md="4" sm="6">
                    <v-card
                        tile
                        elevation="0"
                        class='card-info-about-us'
                    >
                        <v-row 
                            class='card-text-custom' 
                            align="center"
                            justify="center"
                        >
                            <v-col cols="4" class='text-center col-sm-5 col-md-4'>
                                <v-img 
                                    :src="`${require('@/assets/nosotros-pedidos.png')}`" 
                                    style='width:100px;margin:0 auto'  
                                />
                            </v-col>
                            <v-col cols="8" class='text-md-left text-center col-sm-7 col-md-8'>
                                <h2 class='font-title'><b><i>+ 10.000</i></b></h2>
                                <h5 class='font-text font-weight-regular'>pedidos entregados</h5>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
                <v-col cols="12" md="4" sm="6">
                    <v-card
                        tile
                        elevation="0"
                        class='card-info-about-us'
                    >
                        <v-row
                            align="center"
                            justify="center"
                            class='card-text-custom'
                        >
                            <v-col cols="4" class='text-center col-sm-5 col-md-4'>
                                <v-img 
                                    :src="`${require('@/assets/nosotros-ecuador.png')}`" 
                                    style='width:100px;margin:0 auto'  
                                />
                            </v-col>
                            <v-col cols="8" class='text-md-left text-center col-sm-7 col-md-8'>
                                <h2 class='font-title'><b><i>+ 8 AÑOS</i></b></h2>
                                <h5 class='font-text font-weight-regular'>en Ecuador</h5>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
                <v-col cols="12" md="4" sm="6">
                    <v-card
                        tile
                        elevation="0"
                        class='card-info-about-us'
                    >
                        <v-row
                            align="center"
                            justify="center"
                            class='card-text-custom'
                        >
                            <v-col cols="4" class='text-center col-sm-5 col-md-4'>
                                <v-img 
                                    :src="`${require('@/assets/nosotros-clientes.png')}`" 
                                    style="width:100px;margin:0 auto"
                                />
                            </v-col>
                            <v-col cols="8" class='text-md-left text-center col-sm-7 col-md-8'>
                                <h2 class='font-title'><b><i>+ 30 k</i></b></h2>
                                <h5 class='font-text font-weight-regular'>clientes satisfechos</h5>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
            </v-row>
        </div>
        <div class="mx-5 mx-sm-10 mx-md-16 py-md-6 px-md-16 my-6">
            <div class="text-h4 font-weight-bold color-title mb-16 font-title"><i>Equipo:</i></div>
            <v-row>
                <v-col 
                    cols="12" 
                    md=3 
                    v-for="(staff, x) in this.dataWeb.staff"
                >
                    <v-card  tile elevation="0">
                        <v-img
                            :src="`${domain}img/web_commerce/${staff.content_name}`"
                            class="grey darken-4"
                        ></v-img>
                        <v-card-title class="title" style="color:#595758">
                            <b class='font-title'>{{ staff.description }}</b>
                        </v-card-title>
                        <v-card-subtitle>
                            <i class='font-text font-weight-regular'>{{ staff.service_name }}</i>
                        </v-card-subtitle>
                    </v-card>
                </v-col>
            </v-row>
        </div>
        <FooterComponent />
    </div>
</template>

<script>
import HeaderTopComponent from '../partials/HeaderTopComponent'
import MenuComponent from '../partials/MenuComponent'
import FooterComponent from '../partials/FooterComponent'
import BreadCrumbsComponent from '../partials/BreadCrumbsComponent'
import MenuMovilComponent from '../partials/MenuMovilComponent'
import {mapState} from 'vuex'

export default {
    name:'IndexComponent',
    data: ()=> ({
        breadcrumbs:[
            {name:'Inicio',url:'/'},
            {name:'Nosotros',url:'/nosotros'}
        ],
        domain: process.env.VUE_APP_NODE_ENV === "production" ? process.env.VUE_APP_API_URL_PROD : process.env.VUE_APP_API_URL_DEVEL,
    }),
    components:{
        HeaderTopComponent,
        MenuComponent,
        FooterComponent,
        BreadCrumbsComponent,
        MenuMovilComponent      
    },
    computed:{
        menuMovil(){
            return this.$vuetify.breakpoint.name == 'sm' || this.$vuetify.breakpoint.name == 'xs'
        },
        ...mapState(['scrollTop','dataWeb'])
    },
    created(){
      
    }

}
</script>

<style scope>

    .card-info-about-us{
		background-color:transparent!important;
		color:#595754!important;
		font-weight: bold;
		font-size: 1.4rem;
		line-height: .9;
		border-radius: 12px!important;
    	bottom: 40px;
	}

    .v-application .text-h4{
        font-family: Asap!important;
    }
</style>
